import { useQuery, UseQueryOptions } from 'react-query';
import { QueryKeys } from '.';
import { useApi } from '../../context';
import { Product } from '../../models';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';

export function useCreditExplorerProductsQuery(
	options?: Omit<UseQueryOptions<Product[], unknown, Product[], string[]>, 'queryKey' | 'queryFn'>
) {
	const api = useApi();
	return useQuery(
		QueryKeys.Lookups.ExplorerProducts(),
		() => AxiosUtils.getResponseData<Product[]>(api.get(CerebroApiEndpoints.Lookups.ExplorerProducts())),
		options
	);
}
